import { render, staticRenderFns } from "./SkipLink.vue?vue&type=template&id=4ac09f7b&"
import script from "./SkipLink.vue?vue&type=script&lang=ts&"
export * from "./SkipLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BixLink: require('/root/project/frontend/src/components/BixLink.vue').default})
